<ng-container *ngIf="user$ | async as user">
  <ish-account-overview [user]="user" [customer]="customer$ | async" />
</ng-container>
